"use client";
import { PrizeTypes } from "@/api/home";
import { Card } from "@/components/Card";
import { useTranslations } from "next-intl";
import { FC } from "react";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

interface Props {
    data: PrizeTypes[];
}

const HomePrize: FC<Props> = (props) => {
    const { data } = props;
    const t = useTranslations("HomePage");
    const tt = useTranslations("Game");

    return (
        <div
            className={
                "my-[0.0694rem] bg-[url(/home/prize.webp)] bg-[length:100%_100%] px-[.1rem] pb-[.2rem] pt-[.15rem]"
            }
        >
            {/* <div className={"mb-[0.0347rem]"}>{t("prize")}</div> */}
            <Swiper
                slidesPerView={3.2}
                spaceBetween={30}
                pagination={{
                    clickable: true,
                }}
                loop
                autoplay={{
                    delay: 3000,
                }}
                modules={[Autoplay]}
                className="mySwiper"
            >
                {data.map((prize, index: number) => (
                    <SwiperSlide key={index}>
                        <div className={"w-[1.1rem]"} style={{ borderRadius: ".1rem" }}>
                            <Card item={prize} />
                            <div className={"px-[0.13rem] pb-[0.0347rem] text-[0.13rem]"}>
                                <p className={"mt-[.05rem] text-[#b77fff]"}>
                                    {prize.phone
                                        ? prize.phone.slice(0, 3) + "*****" + prize.phone.slice(-3)
                                        : ""}
                                </p>
                                <p className={"text-[#43c937]"}>R${prize.amount}</p>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default HomePrize;
